
<div class="plans-body">
  <div *ngFor="let subscription of subscriptions">
    <div style="margin-top: 15px;">
      <div class="card-image">
        <div class="card-footer">
          <h4 class="card-title title-tlh4-1">{{ subscription.Plano.Nome }}</h4>
        </div>

        <div class="body">
          <!-- <h4 class="title-tlh4-2">{{ subscription.BeneficiadoTag }}</h4> -->

          <mat-accordion>
              <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
                <mat-expansion-panel-header>
  
                  <mat-panel-description>
                  <h5 class="title-tlh5-1" style="font-size: 15px;">Detalhes</h5>
                  </mat-panel-description>
                </mat-expansion-panel-header>
                <h4 style="color: #d41525;">Descrição</h4>
                <p>{{ subscription.Plano.Descricao }}</p>
                <!-- <h3>Datas de cobrança</h3> -->
                <span *ngFor="let detalhe of subscription.Plano.Detalhes">

                  <mat-form-field class="margin-25px">
                    <mat-select placeholder="Cartão para cobrança" [(ngModel)]="subscription.CartaoParaCobrancaId"  (selectionChange)="changePaymentMethod(subscription.Id, subscription.CartaoParaCobrancaId)">
                      <mat-option *ngFor="let paymentMethod of paymentMethods" [value]="paymentMethod.value">
                        {{paymentMethod.title}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>

                  <!-- <span *ngFor="let data of detalhe.DatasPeriodicidadeManual">
                      <p>{{ data | date: 'dd/MM/yyyy' }}</p>
                  </span> -->

                  <h4 style="color: #d41525;">Valor total</h4>
                  <p><span style="font-size: 15px; font-weight: 400;">R$ {{ subscription.Plano.ValorTotal.toFixed(2).toString().split('.')[0] }},{{ subscription.Plano.ValorTotal.toFixed(2).toString().split('.')[1] }}</span></p>
                </span>
              </mat-expansion-panel>
            </mat-accordion>

          <h5 class="title-tlh5-1" style="color: #d41525;">Beneficiário</h5>
          <h5 class="title-tlh5-2">{{ subscription.BeneficiadoNome }}</h5>

          <div>
            <button class="confirma" (click)="cancel(subscription.Id)">
              Cancelar
            </button>
          </div>
        </div>
        
      </div>
    </div>
  </div>

  <mat-list-item *ngIf="!hasDependents">
      <div class="lista-cartao-ativar">
        <ul class="margin-25px">
          <li>
            <div style="text-align: center;">
              <img src="assets/images/no-plan2.jpeg">
            </div>
          </li>
        </ul>
      </div>
    </mat-list-item>

  
</div>



// WEBPACK FOOTER //
// /usr/src/app/src/app/components/current-subscription/current-subscription.component.html